module.exports = __webpack_public_path__ + "img/allProctoring.b876b601.svg";